document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.el-comparison__slider', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 16,
    watchOverflow: true,
    pagination: {
      el: '.el-comparison__pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      361: {
        slidesPerView: 2.3,
      },
      980: {
        slidesPerView: 3,
        spaceBetween: 44,
      }
    }
  });
});